/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $RoomsStatus = {
    properties: {
        id: {
    type: 'number',
},
        name: {
    type: 'string',
},
        rooms: {
    type: 'array',
    contains: {
        type: 'RoomStatus',
    },
},
    },
};